import { useIntl } from '@capsicum/common';
import { useMemo } from 'react';

export type NotAFanProps = {
	closeModal: () => void;
	currentBalance?: number;
	neededTokenAmount: number;
	onButtonPress: () => void;
	testID: string;
	tokenShortCode: string;
};

export const useNotAFan = (tokenShortCode: string) => {
	const { $t } = useIntl();

	const title = useMemo<string>(() => $t('marketplace.tokenBalance.fanTokensNeeded'), [$t]);

	const description = useMemo<string>(
		() =>
			$t('marketplace.tokenBalance.getFanTokens', {
				shortName: tokenShortCode
			}),
		[$t, tokenShortCode]
	);

	const amountText = useMemo<string>(() => $t('marketplace.tokenBalance.amount'), [$t]);

	const yourBalanceText = useMemo<string>(() => $t('marketplace.tokenBalance.yourBalance'), [$t]);

	const amountNeededText = useMemo<string>(() => $t('marketplace.tokenBalance.amountNeeded'), [$t]);

	const purchaseButtonText = useMemo<string>(() => $t('marketplace.buyFanTokens'), [$t]);

	return {
		amountNeededText,
		amountText,
		description,
		purchaseButtonText,
		title,
		yourBalanceText
	};
};
